  import { Navigate } from 'react-router-dom';
import { lazy, createRef } from 'react';

const SimpleLayout = lazy(() => import('../layouts/simple'));
const DashboardLayout = lazy(() => import('../layouts/dashboard'));
const BlogPage = lazy(() => import('../pages/BlogPage'));
const UserPage = lazy(() => import('../pages/User/UserPage'));
const ProviderPage = lazy(() => import('../pages/ProviderPage'));
const AdminPage = lazy(() => import('../pages/Admin/AdminPage'));
const ListingPage = lazy(() => import('../pages/ListingModule/ListingTabs'));
const AdsListingPage = lazy(() => import('../pages/Ads/ListingPage'));
const ListAmenityCategory = lazy(() => import('../pages/Amenity/ListAmenityCategory'));
const ListPrivileges = lazy(() => import('../pages/Privileges/ListPrivileges'));
// const ListPrivilegesCategory = lazy(() => import('../pages/Privileges/ListPrivileges'));
const ListProperty = lazy(() => import('../pages/ListProperty'));
const ListCategory = lazy(() => import('../pages/ListCategory/ListCategory'));
const ListAmenityData = lazy(() => import('../pages/Amenity/ListAmenityData'));
const ListPrivilegesCategory = lazy(() => import('../pages/Privileges/ListPrivilegesCategory'));
const ListPrivilegeItems = lazy(() => import('../pages/Privileges/ListPrivilegeItems'));
const AddMenityCategory = lazy(() => import('../pages/Amenity/AddAmenityCategory'));
const AddPrivilegeCategory = lazy(() => import('../pages/Privileges/AddPrivilegeCategory'));
const Pendings = lazy(() => import('../pages/Booking/PendingBooking'));
const Accepted = lazy(() => import('../pages/Booking/AcceptedBooking'));
const Booking = lazy(() => import('../pages/Booking'));
const Cancel = lazy(() => import('../pages/Booking/CancelBooking'));
const CurrentTrip = lazy(() => import('../pages/Booking/CurrentBookings'));
const UpcomingTrip = lazy(() => import('../pages/UpcomingTrips'));
const AddProfile = lazy(() => import('../pages/Admin/AddProfile'));
const LoginPage = lazy(() => import('../pages/Auth/LoginPage'));
const EditProvider = lazy(() => import('../pages/EditProvider'));
const EditUser = lazy(() => import('../pages/User/EditUser'));
const EditAdmin = lazy(() => import('../pages/Admin/EditAdmin'));
const Page404 = lazy(() => import('../pages/Page404'));
const ProductsPage = lazy(() => import('../pages/ProductsPage'));
const DashboardAppPage = lazy(() => import('../pages/Auth/DashboardAppPage'));
const Offers = lazy(() => import('../pages/Offers/offersList'));
const AddOffers = lazy(() => import('../pages/Offers/AddOffer'));
const EditOffers = lazy(() => import('../pages/Offers/EditOffer'));
const IconPage = lazy(() => import('../pages/RulesIcon/ListRulesIcon'));
const Addicon = lazy(() => import('../pages/RulesIcon/AddRulesIcon'));
const Editamenity = lazy(() => import('../pages/Amenity/Editamenitycategory'));
const EditPrivilege = lazy(() => import('../pages/Privileges/EditPrivilege'));
const Editamenitydata = lazy(() => import('../pages/Amenity/Editamenitydata'));
const Editprivilegedata = lazy(() => import('../pages/Privileges/EditPrivilegeData'));
const Editprivilegeitems = lazy(() => import('../pages/Privileges/EditPrivilegeItems'));
const SendNotification = lazy(() => import('../pages/Auth/Notification'));
const Notifications = lazy(() => import('../pages/Auth/viewnotification'));
const TransactionHistory = lazy(() => import('../pages/Trancactionhistory'));
const Wallet = lazy(() => import('../pages/Wallet'));
const AdminProfile = lazy(() => import('../pages/Admin/AdminProfile'));
const Commission = lazy(() => import('../pages/Commission'));
const EditCategory = lazy(() => import('../pages/ListCategory/EditCategory'));
const EditProperty = lazy(() => import('../pages/Listings/EditProperty'));
const TransactionDetails = lazy(() => import('../pages/transactiondetails'));
const SingleListing = lazy(() => import('../pages/singlelisting'));
const EmailTemplate = lazy(() => import('../pages/emailTemplate'));
const Template = lazy(() => import('../pages/template'));
const EditemailTemplate = lazy(() => import('../pages/editTemplate'));
const EditTemplate = lazy(() => import('../pages/editTem'));
const Cms = lazy(() => import('../pages/CMS/Cms'));
const Howdoeswork = lazy(() => import('../pages/Howdoeswork'));
const CmsTemplate = lazy(() => import('../pages/CMS/cmsTemplate'));
const CmsEditTemplate = lazy(() => import('../pages/CMS/editCmsTemplate'));
const Settings = lazy(() => import('../pages/settings'));
const Gallery = lazy(() => import('../pages/Gallery/gallery'));
const AddGallery = lazy(() => import('../pages/Gallery/AddGallery'));
const AddImages = lazy(() => import('../pages/Gallery/AddImages'));
const EditGallery = lazy(() => import('../pages/Gallery/EditGallery'));
const Report = lazy(() => import('../pages/Report/report'));
const ReportForm = lazy(() => import('../pages/Report/ReportForm'));
const UserReport = lazy(() => import('../pages/Report/UserReport/UserReport'));
const EditUserReport = lazy(() => import('../pages/Report/UserReport/EditUserReport'))
const ReportUser = lazy(() => import('../pages/ReportUser/reportUser'));
const ReportUserForm = lazy(() => import('../pages/ReportUser/reportUserForm'));
const ReportUserList = lazy(() => import('../pages/ReportUser/ReportUserList/reportUserList'));
const ReportUserListForm = lazy(() => import('../pages/ReportUser/ReportUserList/editUserReportList'));
const PackagesList = lazy(() => import('../pages/PackageSubscriptions/listPackages'));
const PackagesForm = lazy(() => import('../pages/PackageSubscriptions/packagesForm'));
const Advertisement = lazy(() => import('../pages/Advertisement/viewAdvertisement'));
const EditAdvertisement = lazy(() => import('../pages/Advertisement/editAdvertisement'));
const CatgeorySubCategory = lazy(() => import('../pages/Category&Subcategory/viewCategory'));
const AdvCategoryForm = lazy(() => import('../pages/Category&Subcategory/advCategoryForm'));
const AdvSubCategory = lazy(() => import('../pages/Category&Subcategory/SubCategory/viewSubCategory'));
const AdvSubCategoryForm = lazy(() => import('../pages/Category&Subcategory/SubCategory/subCategoryForm'));
const ViewReviewManagment = lazy(() => import('../pages/ReviewManagement/viewReview'));
const ThemeManagement = lazy(() => import('../pages/ThemeManagement/index'));
const AdFormManagement = lazy(() => import('../pages/Ads/FormManagement'));
const FormManagement = lazy(() => import('../pages/Listings/FormManagement'));
const ViewAdminReplies = lazy(() => import('../pages/ReviewManagement/viewAdminReplies'));
// const AddReport = lazy(() => import('../pages/Report/addReport'));
const EarningsReport = lazy(() => import('../pages/EarningsReport/earningsReport'))
const CreateListing = lazy(() => import('../pages/Listings/CreateListing'));
const CommissionAndTax = lazy(() => import('../pages/Commission&Tax'));
const HiddenSettings = lazy(() => import('../pages/hiddenSettings'));
const Language = lazy(() => import('../pages/Language/Language'));
const Translations = lazy(() => import('../pages/Language/Translations'));
const AddListings = lazy(() => import('../pages/AddListing/AddListing'));
const EditListing = lazy(() => import('../pages/Listings/editlisting'));
const EditAdListing = lazy(() => import('../pages/Ads/EditAdListing'));
const AdminRoles = lazy(() => import('../pages/AdminRoles/viewAdminRoles'));
const AdminRolesForm = lazy(() => import('../pages/AdminRoles/adminRolesForm'));
const PushNotificationList = lazy(() => import('../pages/PushNotificationTemplate/TemplateList'));
const PushNotificationForm = lazy(() => import('../pages/PushNotificationTemplate/TemplateForm'));
// import Transaction from './pages/Transaction';
// eslint-disable-next-line spaced-comment
//import PerviousTrip from './pages/PerviousTrips';
// ----------------------------------------------------------------------

export const DashboardRoutes = [
    { nodeRef: createRef(), element: <Navigate to="/dashboard/app" />, index: true },
    { path: 'app', nodeRef: createRef(), element: <DashboardAppPage /> },
    { path: 'user', nodeRef: createRef(), element: <UserPage /> },
    { path: 'provider', nodeRef: createRef(), element: <ProviderPage /> },
    { path: 'products', nodeRef: createRef(), element: <ProductsPage /> },
    { path: 'admin', nodeRef: createRef(), element: <AdminPage /> },
    { path: 'blog', nodeRef: createRef(), element: <BlogPage /> },
    { path: 'addprofile', nodeRef: createRef(), element: <AddProfile /> },
    { path: 'editprovider', nodeRef: createRef(), element: <EditProvider /> },
    { path: 'edituser', nodeRef: createRef(), element: <EditUser /> },
    { path: 'editadmin', nodeRef: createRef(), element: <EditAdmin /> },
    { path: 'listing', nodeRef: createRef(), element: <ListingPage /> },
    { path: 'ads-listing', nodeRef: createRef(), element: <AdsListingPage /> },
    { path: 'amenitycategory', nodeRef: createRef(), element: <ListAmenityCategory /> },
    { path: 'privilegecategory', nodeRef: createRef(), element: <ListPrivileges /> },
    // { path: 'privilegecategory', nodeRef: createRef(), element: <ListPrivilegesCategory /> },
    { path: 'addamenity', nodeRef: createRef(), element: <AddMenityCategory /> },
    { path: 'addprivilege', nodeRef: createRef(), element: <AddPrivilegeCategory /> },
    { path: 'property', nodeRef: createRef(), element: <ListProperty /> },
    { path: 'category', nodeRef: createRef(), element: <ListCategory /> },
    { path: 'amenitydata', nodeRef: createRef(), element: <ListAmenityData /> },
    { path: 'privilegedata', nodeRef: createRef(), element: <ListPrivilegesCategory /> },
    { path: 'privilegeitems', nodeRef: createRef(), element: <ListPrivilegeItems /> },
    { path: 'pendingbooking', nodeRef: createRef(), element: <Pendings /> },
    { path: 'acceptedbooking', nodeRef: createRef(), element: <Accepted /> },
    { path: 'bookinghistory', nodeRef: createRef(), element: <Booking /> },
    { path: 'cancellationhistory', nodeRef: createRef(), element: <Cancel /> },
    { path: 'currenttrips', nodeRef: createRef(), element: <CurrentTrip /> },
    { path: 'upcomingtrips', nodeRef: createRef(), element: <UpcomingTrip /> },
    //    { path: 'previoustrips', nodeRef: createRef(), element: <PerviousTrip /> },
    { path: 'offers', nodeRef: createRef(), element: <Offers /> },
    { path: 'addoffers', nodeRef: createRef(), element: <AddOffers /> },
    { path: 'editoffers', nodeRef: createRef(), element: <EditOffers /> },
    { path: 'pushNotification', nodeRef: createRef(), element: <PushNotificationList /> },
    { path: 'pushNotificationForm', nodeRef: createRef(), element: <PushNotificationForm /> },
    { path: 'icon', nodeRef: createRef(), element: <IconPage /> },
    { path: 'addicon', nodeRef: createRef(), element: <Addicon /> },
    { path: 'editamenitycategory', nodeRef: createRef(), element: <Editamenity /> },
    { path: 'editprivilege', nodeRef: createRef(), element: <EditPrivilege /> },
    // { path: 'editprivilegecategory', nodeRef: createRef(), element: <EditPrivilegeCategory /> },
    // { path: 'editamenitycategory/:ids', nodeRef: createRef(), element: <Editamenity /> },
    { path: 'editamenitydata/:amenitytId', nodeRef: createRef(), element: <Editamenitydata /> },
    { path: 'editprivilegedata/:privilegeId', nodeRef: createRef(), element: <Editprivilegedata /> },
    { path: 'editprivilegeitems/:privilegeId', nodeRef: createRef(), element: <Editprivilegeitems /> },
    { path: 'Sendnotification', nodeRef: createRef(), element: <SendNotification /> },
    { path: 'notifications', nodeRef: createRef(), element: <Notifications /> },
    { path: 'TransactionHistory', nodeRef: createRef(), element: <TransactionHistory /> },
    { path: 'wallet', nodeRef: createRef(), element: <Wallet /> },
    { path: 'Language', nodeRef: createRef(), element: <Language /> },
    { path: 'translations', nodeRef: createRef(), element: <Translations /> },
    { path: 'AdminProfile', nodeRef: createRef(), element: <AdminProfile /> },
    { path: 'Commission', nodeRef: createRef(), element: <Commission /> },
    { path: 'EditCategory/:catid', nodeRef: createRef(), element: <EditCategory /> },
    { path: 'EditProperty/:propid', nodeRef: createRef(), element: <EditProperty /> },
    { path: 'Transactindetails' , nodeRef: createRef(), element:<TransactionDetails/>},
    { path: 'singleListing' , nodeRef: createRef(), element:<SingleListing/>},
    { path: 'template' , nodeRef: createRef(), element:<Template/>},
    { path: 'emailtemplate' , nodeRef: createRef(), element:<EmailTemplate/>},
    { path: 'editTemplate' , nodeRef: createRef(), element:<EditemailTemplate/>},
    { path: 'editemailTemplate' , nodeRef: createRef(), element:<EditTemplate/>},
    { path:'Cms',nodeRef: createRef(), element:<Cms/>},
    { path:'how-does-work',nodeRef: createRef(), element:<Howdoeswork />},
    { path:'CmsTemplate',nodeRef: createRef(), element:<CmsTemplate/>},
    { path:'EditcmsTemplate',nodeRef: createRef(), element:<CmsEditTemplate/>},
    { path:'settings',nodeRef: createRef(), element:<Settings/>},
    { path:'apps-settings',nodeRef: createRef(), element:<Settings/>},
    { path:'payment-settings',nodeRef: createRef(), element:<Settings/>},
    { path:'currency-settings',nodeRef: createRef(), element:<Settings/>},
    { path:'mailgateway-settings',nodeRef: createRef(), element:<Settings/>},
    { path:'pwa-settings',nodeRef: createRef(), element:<Settings/>},
    { path: 'gallery', nodeRef: createRef(), element: <Gallery />},
    { path: 'addGallery', nodeRef: createRef(), element: <AddGallery />},
    { path: 'addImages', nodeRef: createRef(), element: <AddImages />},
    { path: 'editGallery', nodeRef: createRef(), element: <EditGallery />},

    { path: 'report', nodeRef: createRef(), element: <Report />},
    { path: 'reportForm', nodeRef: createRef(), element: <ReportForm />},
    { path: 'userReport', nodeRef: createRef(), element: <UserReport />},
    { path: 'editUserReport', nodeRef: createRef(), element: <EditUserReport />},

    { path: 'reportUser', nodeRef: createRef(), element: <ReportUser />},
    { path: 'reportUserForm', nodeRef: createRef(), element: <ReportUserForm />},
    { path: 'reportUserList', nodeRef: createRef(), element: <ReportUserList />},
    { path: 'reportUserListForm', nodeRef: createRef(), element: <ReportUserListForm />},
    { path: 'packagesList', nodeRef: createRef(), element: <PackagesList />},
    { path: 'packagesForm', nodeRef: createRef(), element: <PackagesForm />},

    { path: 'earningsReport', nodeRef: createRef(), element: <EarningsReport />},
    { path: 'advertisement', nodeRef: createRef(), element: <Advertisement />},
    { path: 'editAdvertisement', nodeRef: createRef(), element: <EditAdvertisement />},
    { path: 'category&subcategory', nodeRef: createRef(), element: <CatgeorySubCategory />},
    { path: 'advCategoryform', nodeRef: createRef(), element: <AdvCategoryForm />},
    { path: 'advSubCategory', nodeRef: createRef(), element: <AdvSubCategory />},
    { path: 'advSubCategoryForm', nodeRef: createRef(), element: <AdvSubCategoryForm />},
    { path: 'adminRoles', nodeRef: createRef(), element: <AdminRoles />},
    { path: 'adminRolesForm', nodeRef: createRef(), element: <AdminRolesForm />},
    { path: 'reviewManagement', nodeRef: createRef(), element: <ViewReviewManagment />},
    { path: 'themeManagement', nodeRef: createRef(), element: <ThemeManagement />},
    { path: 'adFormManagement', nodeRef: createRef(), element: <AdFormManagement />},
    { path: 'FormManagement', nodeRef: createRef(), element: <FormManagement />},
    { path: 'reviewAdminReplies', nodeRef: createRef(), element: <ViewAdminReplies />},
    // { path: 'addReport', nodeRef: createRef(), element: <AddReport />},
    { path:'abssettings',nodeRef: createRef(), element:<HiddenSettings/>},
    { path:'createlistings',nodeRef: createRef(), element:<CreateListing/>},
    { path:'Commission&Tax',nodeRef: createRef(), element:<CommissionAndTax/>},
    { path:'addlisting',nodeRef: createRef(), element:<AddListings/>},
    { path:'editlisting',nodeRef: createRef(), element:<EditListing/>},
    { path:'editadlisting',nodeRef: createRef(), element:<EditAdListing/>},

  ];

export default [
    {
      path: '/dashboard',
      nodeRef: createRef(), element: <DashboardLayout />,
      children: DashboardRoutes,
    },
    {
      path: 'login',
      nodeRef: createRef(), element: <LoginPage />,
    },
    {
      nodeRef: createRef(), element: <SimpleLayout />,
      children: [
        { nodeRef: createRef(), element: <Navigate to="/login" />, index: true },
        { path: '404', nodeRef: createRef(), element: <Page404 /> },
        // { path: '500', nodeRef: createRef(), element: <Page500/> }, 
        { path: '*', nodeRef: createRef(), element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      nodeRef: createRef(), element: <Navigate to="/404" replace />,
    },
  ];
